export function useHreflang(localeSlugs) {
  const config = useRuntimeConfig();
  const base = (config.public.baseUrl + "/blog").replace(/\/$/, "");

  const urls = Object.fromEntries(
    Object.entries(localeSlugs).map(([locale, path]) => [
      locale,
      `${base}${path}`,
    ]),
  );

  const hreflangMap = { en: "en", fr: "fr", es: "es", de: "de" };

  const alternateLinks = Object.entries(urls).map(([locale, url]) => ({
    rel: "alternate",
    hreflang: hreflangMap[locale] ?? locale,
    href: url,
  }));

  if (urls.en) {
    alternateLinks.push({
      rel: "alternate",
      hreflang: "x-default",
      href: urls.en,
    });
  }

  const { locale } = useI18n?.() ?? { locale: { value: "en" } };
  const currentLocale = locale?.value ?? "en";
  const canonicalUrl = urls[currentLocale] ?? urls.en;

  useHead({
    link: [{ rel: "canonical", href: canonicalUrl }, ...alternateLinks],
  });
}
